module.exports = require("@embedpdf/core");